var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import crypto from 'crypto';
import { Base64 } from 'js-base64';
import Moment from 'moment-timezone';
import { PaymentAdapter, PaymentVendors } from '../Interfaces/interface.adapter';
import { PaymentErrorShortCodes, PaymentMethod } from '../Interfaces';
import { PaymentClientError, PaymentValidationError } from '..';
import { Config } from '../Configs';
window.opera = window.opera || {};
var PaymentAdapterInicis = /** @class */ (function (_super) {
    __extends(PaymentAdapterInicis, _super);
    function PaymentAdapterInicis(env, vendorSessionInfo, billingContactInfo) {
        var _this = _super.call(this) || this;
        _this.vendorName = PaymentVendors.inicis;
        _this.threeDSecurePayload = {};
        _this.env = env;
        _this.vendorSessionInfo = vendorSessionInfo;
        _this.billingContactInfo = billingContactInfo;
        if (typeof INIStdPay === 'undefined') {
            throw new PaymentClientError('Cannot find vendor module, please make sure to load it', PaymentErrorShortCodes.missing_vendor_library, {
                cause: { message: 'INICIS vendor module not loaded' }
            });
        }
        return _this;
    }
    Object.defineProperty(PaymentAdapterInicis.prototype, "threeDSPayload", {
        set: function (payload) {
            if (!payload) {
                throw new PaymentClientError('Invalid 3DS payload', PaymentErrorShortCodes.invalid_3ds_payload);
            }
            this.threeDSecurePayload = payload;
        },
        enumerable: false,
        configurable: true
    });
    PaymentAdapterInicis.prototype.encryptCreditCardData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new PaymentClientError('Payment Method is not supported', PaymentErrorShortCodes.unsupported_payment_method);
            });
        });
    };
    PaymentAdapterInicis.prototype.encryptACHData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new PaymentClientError('Payment Method is not supported', PaymentErrorShortCodes.unsupported_payment_method);
            });
        });
    };
    PaymentAdapterInicis.prototype.initializeWebDropIn = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new PaymentClientError('Payment Method is not supported', PaymentErrorShortCodes.unsupported_payment_method);
            });
        });
    };
    PaymentAdapterInicis.prototype.initializeWebComponent = function (divId, paymentMethod) {
        return __awaiter(this, void 0, void 0, function () {
            var inicisPaymentMethod, phoneNumber, inicisSession, paymentDiv, inicisForm_1, isMobileBrowser_1, billingToken, amount, email, paymentNotificationUrl, inicisMerchantData, encodedInicisMerchantData, inTwoDays, formattedInTwoDaysDate, formattedInTwoDaysTime, billingToken, amount, timestamp, signatureToEncode, signatureHash, email, inicisMerchantData, encodedInicisMerchantData, inTwoDays, formattedInTwoDays, paymentButton, e_1;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        switch (paymentMethod) {
                            case PaymentMethod.webComponentCreditCard:
                                inicisPaymentMethod = 'Card';
                                break;
                            case PaymentMethod.webComponentVirtualAccount:
                                inicisPaymentMethod = 'VBank';
                                break;
                            default:
                                throw new PaymentClientError('Payment Method is not supported', PaymentErrorShortCodes.unsupported_payment_method);
                        }
                        phoneNumber = (_a = this.billingContactInfo.contactInfo) === null || _a === void 0 ? void 0 : _a.phone;
                        if (!phoneNumber) {
                            throw new PaymentValidationError("Phone number is missing, contains illegal characters or has illegal format", PaymentErrorShortCodes.invalid_phone);
                        }
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.getDecodedVendorSessionPayload()];
                    case 2:
                        inicisSession = (_d.sent());
                        paymentDiv = document.getElementById(divId);
                        if (!paymentDiv) {
                            throw new Error('Cannot find element with the provided divId: ' + divId);
                        }
                        inicisForm_1 = document.createElement('form');
                        inicisForm_1.id = 'inicisPaymentFormId-' + Math.random().toString(36).substring(6);
                        paymentDiv.appendChild(inicisForm_1);
                        isMobileBrowser_1 = PaymentAdapterInicis.isMobileBrowser();
                        if (isMobileBrowser_1) {
                            inicisForm_1.name = 'mobileweb';
                            inicisForm_1.acceptCharset = 'euc-kr';
                            // List of required parameters for mobile web can be found at:
                            // https://manual.inicis.com/mobile/
                            this.addInputToForm(inicisForm_1, 'P_INI_PAYMENT', inicisPaymentMethod);
                            this.addInputToForm(inicisForm_1, 'P_MID', inicisSession.merchantId);
                            billingToken = this.vendorSessionInfo.billingToken;
                            this.addInputToForm(inicisForm_1, 'P_OID', billingToken);
                            amount = inicisSession.amount / 100;
                            this.addInputToForm(inicisForm_1, 'P_AMT', amount.toString());
                            this.addInputToForm(inicisForm_1, 'P_GOODS', inicisSession.productName);
                            this.addInputToForm(inicisForm_1, 'P_MOBILE', phoneNumber);
                            email = ((_b = this.billingContactInfo.contactInfo) === null || _b === void 0 ? void 0 : _b.email) || '';
                            this.addInputToForm(inicisForm_1, 'P_EMAIL', email);
                            this.addInputToForm(inicisForm_1, 'P_UNAME', this.billingContactInfo.name.last);
                            this.addInputToForm(inicisForm_1, 'P_NEXT_URL', inicisSession.returnUrl);
                            paymentNotificationUrl = Config.getBasePaymentUrl(this.env) + "/vendors/inicis/notifications";
                            this.addInputToForm(inicisForm_1, 'P_NOTI_URL', paymentNotificationUrl);
                            this.addInputToForm(inicisForm_1, 'P_CHARSET', 'utf8');
                            inicisMerchantData = {
                                paymentMethod: paymentMethod,
                                sessionId: this.vendorSessionInfo.sessionId
                            };
                            encodedInicisMerchantData = Base64.encode(JSON.stringify(inicisMerchantData));
                            this.addInputToForm(inicisForm_1, 'P_NOTI', encodedInicisMerchantData);
                            this.addInputToForm(inicisForm_1, 'P_QUOTABASE', '1:2:3:4:5:6:7:8:9:10:11:12');
                            inTwoDays = Moment(this.vendorSessionInfo.timestamp).add(2, 'day').tz('Asia/Seoul');
                            formattedInTwoDaysDate = Moment(inTwoDays).format('YYYYMMDD');
                            this.addInputToForm(inicisForm_1, 'P_VBANK_DT', formattedInTwoDaysDate);
                            formattedInTwoDaysTime = Moment(inTwoDays).format('HHmm');
                            this.addInputToForm(inicisForm_1, 'P_VBANK_TM', formattedInTwoDaysTime);
                            this.addInputToForm(inicisForm_1, 'P_RESERVED', 'vbank_receipt=Y');
                        }
                        else {
                            // List of required parameters can be found at:
                            // https://manual.inicis.com/stdpay/
                            this.addInputToForm(inicisForm_1, 'version', '1.0');
                            this.addInputToForm(inicisForm_1, 'mid', inicisSession.merchantId);
                            this.addInputToForm(inicisForm_1, 'mKey', inicisSession.merchantKeyHash);
                            this.addInputToForm(inicisForm_1, 'gopaymethod', inicisPaymentMethod);
                            billingToken = this.vendorSessionInfo.billingToken;
                            this.addInputToForm(inicisForm_1, 'oid', billingToken);
                            amount = inicisSession.amount / 100;
                            this.addInputToForm(inicisForm_1, 'price', amount.toString());
                            timestamp = new Date(this.vendorSessionInfo.timestamp).getTime().toString();
                            this.addInputToForm(inicisForm_1, 'timestamp', timestamp);
                            signatureToEncode = "oid=".concat(billingToken, "&price=").concat(amount, "&timestamp=").concat(timestamp);
                            signatureHash = crypto.createHash('sha256').update(signatureToEncode).digest('hex');
                            this.addInputToForm(inicisForm_1, 'signature', signatureHash);
                            this.addInputToForm(inicisForm_1, 'currency', inicisSession.currency);
                            this.addInputToForm(inicisForm_1, 'goodname', inicisSession.productName);
                            this.addInputToForm(inicisForm_1, 'buyertel', phoneNumber);
                            email = ((_c = this.billingContactInfo.contactInfo) === null || _c === void 0 ? void 0 : _c.email) || '';
                            this.addInputToForm(inicisForm_1, 'buyeremail', email);
                            this.addInputToForm(inicisForm_1, 'buyername', this.billingContactInfo.name.last);
                            this.addInputToForm(inicisForm_1, 'closeUrl', inicisSession.closeUrl);
                            this.addInputToForm(inicisForm_1, 'returnUrl', inicisSession.returnUrl);
                            inicisMerchantData = {
                                paymentMethod: paymentMethod,
                                sessionId: this.vendorSessionInfo.sessionId
                            };
                            encodedInicisMerchantData = Base64.encode(JSON.stringify(inicisMerchantData));
                            this.addInputToForm(inicisForm_1, 'merchantData', encodedInicisMerchantData);
                            this.addInputToForm(inicisForm_1, 'quotabase', '1:2:3:4:5:6:7:8:9:10:11:12');
                            inTwoDays = Moment(this.vendorSessionInfo.timestamp).add(2, 'day').tz('Asia/Seoul');
                            formattedInTwoDays = Moment(inTwoDays).format('YYYYMMDDHHmm');
                            this.addInputToForm(inicisForm_1, 'acceptmethod', "vbank(".concat(formattedInTwoDays, ")"));
                            this.addInputToForm(inicisForm_1, 'acceptmethod', ':va_receipt');
                        }
                        paymentButton = document.createElement('button');
                        paymentButton.innerHTML = '결제하기';
                        paymentButton.onclick = function () {
                            if (isMobileBrowser_1) {
                                inicisForm_1.action = 'https://mobile.inicis.com/smart/payment/';
                                inicisForm_1.target = '_self';
                                inicisForm_1.submit();
                            }
                            else {
                                INIStdPay.pay(inicisForm_1.id);
                            }
                        };
                        paymentDiv.appendChild(paymentButton);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _d.sent();
                        throw new PaymentClientError('Error creating web component: ' + e_1.message, PaymentErrorShortCodes.server_session_error, {
                            vendorName: this.vendorName,
                            cause: {
                                message: e_1.message,
                                details: JSON.stringify(e_1)
                            }
                        });
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PaymentAdapterInicis.prototype.addInputToForm = function (form, name, value) {
        var input = document.createElement('input');
        input.name = name;
        input.value = value;
        input.type = 'hidden';
        form.appendChild(input);
    };
    PaymentAdapterInicis.validateInicisVendorResponse = function (
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    vendorResponse) {
        var vendorWebResponse = vendorResponse;
        var vendorMobileResponse = vendorResponse;
        var isMobileBrowserResponse = !(vendorResponse === null || vendorResponse === void 0 ? void 0 : vendorResponse.resultCode);
        var resultCode = isMobileBrowserResponse ? vendorMobileResponse.P_STATUS : vendorWebResponse.resultCode;
        if (!resultCode) {
            throw new PaymentValidationError('Vendor Response has invalid structure', PaymentErrorShortCodes.invalid_vendor_response, {
                cause: {
                    message: 'resultCode / P_STATUS field is empty'
                }
            });
        }
        var resultMessage = isMobileBrowserResponse ? vendorMobileResponse.P_RMESG1 : vendorWebResponse.resultMsg;
        if (!resultMessage) {
            throw new PaymentValidationError('Vendor Response has invalid structure', PaymentErrorShortCodes.invalid_vendor_response, {
                cause: {
                    message: 'resultMsg / P_RMESG1 field is empty'
                }
            });
        }
        var inicisMerchantData;
        try {
            var merchantData = isMobileBrowserResponse ? vendorMobileResponse.P_NOTI : vendorWebResponse.merchantData;
            var decodedMerchantData = Base64.decode(merchantData);
            inicisMerchantData = JSON.parse(decodedMerchantData);
            if (!inicisMerchantData.sessionId) {
                throw new Error('Invalid sessionId');
            }
            if (inicisMerchantData.paymentMethod != PaymentMethod.webComponentCreditCard &&
                inicisMerchantData.paymentMethod != PaymentMethod.webComponentVirtualAccount) {
                throw new Error('Invalid paymentMethod');
            }
        }
        catch (e) {
            throw new PaymentValidationError('Vendor Response has invalid structure', PaymentErrorShortCodes.invalid_vendor_response, {
                cause: {
                    message: 'merchantData / P_NOTI field has invalid value: ' + vendorResponse.merchantData,
                    errorDetails: e.message,
                    details: JSON.stringify(e)
                }
            });
        }
        // Response is valid, let's return it
        vendorResponse.decodedMerchantData = inicisMerchantData;
        return inicisMerchantData;
    };
    PaymentAdapterInicis.isMobileBrowser = function () {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        var isMobileBrowser = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\\-(n|u)|c55\/|capi|ccwa|cdm\\-|cell|chtm|cldc|cmd\\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\\-s|devi|dica|dmob|do(c|p)o|ds(12|\\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\\-|_)|g1 u|g560|gene|gf\\-5|g\\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\\-(m|p|t)|hei\\-|hi(pt|ta)|hp( i|ip)|hs\\-c|ht(c(\\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\\-(20|go|ma)|i230|iac( |\\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\\-[a-w])|libw|lynx|m1\\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\\-2|po(ck|rt|se)|prox|psio|pt\\-g|qa\\-a|qc(07|12|21|32|60|\\-[2-7]|i\\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\\-|oo|p\\-)|sdk\/|se(c(\\-|0|1)|47|mc|nd|ri)|sgh\\-|shar|sie(\\-|m)|sk\\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\\-|v\\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\\-|tdg\\-|tel(i|m)|tim\\-|t\\-mo|to(pl|sh)|ts(70|m\\-|m3|m5)|tx\\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\\-|your|zeto|zte\\-/i.test(userAgent.substr(0, 4));
        return isMobileBrowser;
    };
    PaymentAdapterInicis.prototype.formatThreeDSecurePayload = function () {
        throw new Error('formatThreeDSecurePayload is not supported with Inicis integration');
    };
    return PaymentAdapterInicis;
}(PaymentAdapter));
export { PaymentAdapterInicis };
